import Vue from 'vue'
import store from '@/store/index'
import router from '@/router/index'
import App from '@/components/layout/entry'

import {
    globalConfig,
} from '@/config'
// Plugins start
import './plugins/casl'
import './plugins/vue-progressbar'
import './plugins/vee-validate'
import './plugins/socket-io'
import './plugins/moment'
import './plugins/element-io'
// import './plugins/vue-bar';
import './plugins/vue-datetime'
// import './plugins/vue-inputmask';
// import './plugins/v-mask';
import './plugins/v-tooltip'
import './plugins/multiselect'
import './plugins/vue-tel-input'
// Plugins end

// Libs Start
// import 'normalize.css';
import './assets/sass/reset.scss'
import './assets/sass/style.scss'

import 'vue-datetime/dist/vue-datetime.css'
// Filter Start
import './filters/math'
// Global Components Start
import './globalComponents'
import Swal from 'sweetalert2'

import '@/helpers/index'

import {
    ability,
} from '@/utils/permissions'

import {
    NotificationMananger,
} from '@/mixins/notificationManager'
import {
    i18n,
} from './plugins/vuei8n'

// App core end
window.Swal = Swal
window.layout = 'default'
window.globalConfig = globalConfig

window.$role = 'default'

Vue.prototype.$guard = (what, resource) => ability(window.$role).can(what, resource)
Vue.prototype.$config = globalConfig

// mode
Vue.config.silent = true
window.notificationMananger = new NotificationMananger()

// import '@/helpers/sentry/index';

const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: (h) => h(App),
})

export {
    app,
}
